import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';

export const setAllProfilesLoading = (create: ReducerCreators<AudiencesState>) =>
  create.reducer((state) => {
    state.allProfiles.loadingBase = true;
    state.allProfiles.loadingWatchtime = true;
    state.allProfiles.loadingStarScore = true;
    state.allProfiles.loadingTotal = true;
  });
